import {createInstance} from 'i18next';
import {initReactI18next} from "react-i18next";
import {ruTranslations} from "./ru/locale_ru";
import {enTranslations} from "./en/locale_en";
import moment from "moment";
import {etTranslations} from "./et/locale_et";

export const LOCALE_EN = 'en';
export const LOCALE_RU = 'ru';
export const LOCALE_ET = 'et';

const i18nNola = createInstance();

i18nNola
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translations: {
                    ...enTranslations
                }
            },
            ru: {
                translations: {
                    ...ruTranslations
                }
            },
            et: {
                translations: {
                    ...etTranslations
                }
            },
        },
        lng: LOCALE_EN,
        fallbackLng: false,
        debug: false,
        ns: ["translations"],
        defaultNS: "translations",
        interpolation: {
            escapeValue: false
        }
    });

const changeLanguage = (lang: string) => {
    return i18nNola.changeLanguage(lang)
}

export const setAppLocale = async (lang: string) => {
    moment.locale(lang)
    //Should be the last one
    await changeLanguage(lang)
};

export const getFixedTranslation = (lang?: string) => {
    return i18nNola.getFixedT(lang?.toLowerCase() ?? LOCALE_EN)
}

export default i18nNola;
